// extracted by mini-css-extract-plugin
export default {"container":"Terms-module--container--0a2d1"};